<template>

    <div>


        <div class="sifarnik-top-line">

            <div class="sifarnik-top-left">
                <RouteTab current_tab="Tarife" />
            </div>
            <div class="sifarnik-top-right">
                <div class=" sifarnik-search crm-search" v-if="false"><input type="text"
                        placeholder="Pretraži šifarnik..">
                    <div class="top-search-button"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26"
                            viewBox="0 0 26 26">
                            <g>
                                <g>
                                    <path fill="#fff"
                                        d="M25.714 25.714a.952.952 0 0 1-1.346 0l-6.295-6.295A10.95 10.95 0 0 1 11 21.999C4.925 22 0 17.076 0 11 0 4.926 4.925 0 11 0s11 4.926 11 11c0 2.696-.972 5.161-2.581 7.074l6.295 6.295a.952.952 0 0 1 0 1.346zM20 11a9 9 0 1 0-18 0 9 9 0 0 0 18 0z" />
                                </g>
                            </g>
                        </svg></div>
                </div>
                <div class="upload-stavke-button upload-dokumenta-button " @click="addNew(true)">
                    Unesi novu tarifu
                    <div class="upload-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                            <g>
                                <g>
                                    <path fill="#fff"
                                        d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="sifarnik-main-wrapper">
            <div class="sifarnik-item-wrapper">
                <SingleSifra v-for="(single,key) in sifra_arr" :key="key" :sifra="single" :depth="0"
                    @edit-single="editSingle" @add-parent="newFromParrent" @delete-single="deleteSingle" />
                <v-dialog v-model="popView" width="800px">
                    <v-card color="universal-vcard">
                        <div class="universal-vdialog-title">
                            Unos tarifne stavke
                        </div>
                        <div class="sifra-form-wrapper">
                            <CustomDropdown :id="'drop_parents'" v-model="new_sifra.parrent_id"
                                :drop_items="mappedAll()" init_text="Odaberite skupinu" />
                            <v-text-field class="universal-vdialog-textfield number-field" type="text" label="Tabularni broj"
                                placeholder="Tabularni broj" v-model="new_sifra.number"></v-text-field>
                        </div>
                        <div class="sifra-form-wrapper second-row">
                            <v-text-field class="universal-vdialog-textfield tabularni-name" type="text" placeholder="Naziv tarifne stavke" label="Naziv tarifne stavke"
                                    v-model="new_sifra.name"></v-text-field>
                            <v-text-field class="universal-vdialog-textfield number-field" type="number"
                                placeholder="Broj bodova" label="Broj bodova" v-model="new_sifra.value"
                                v-if="new_sifra.parrent_id != null"></v-text-field>
                        </div>
                        <div class="sifra-opis-wrapper">
                            <v-textarea class="universal-vdialog-textfield" type="text" placeholder="Opis tarifne stavke" label="Opis tarifne stavke"
                                v-model="new_sifra.description"></v-textarea>
                        </div>

                        <div class="vdialog-buttons-wrapper">
                            <div class="universal-vdialog-button vbutton-secondary" @click="clearNewEdit()">
                                Odustani
                            </div>
                            <div class="universal-vdialog-button vbutton-primary" @click="addNewSifra()"> Pohrani
                            </div>
                        </div>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="editingMode " width="800px">
                    <v-card color="universal-vcard">
                        <div class="universal-vdialog-title">
                            Uređivanje tarifne stavke
                        </div>
                        <div class="sifra-form-wrapper">
                            <v-text-field class="universal-vdialog-textfield number-field text1" type="text"
                                label="Tabularni broj" placeholder="Tabularni broj" v-model="edit_sifra.number" readonly></v-text-field>
                            <v-text-field class="universal-vdialog-textfield text2" type="text" placeholder="Naziv tarifne stavke" label="Naziv tarifne stavke"
                                v-model="edit_sifra.name"></v-text-field>
                            <v-text-field class="universal-vdialog-textfield number-field text3" type="number" placeholder="Broj bodova" label="Broj bodova"
                                v-model="edit_sifra.value" v-if="edit_sifra.parrent_id != null"></v-text-field>
                        </div>
                        <div class="sifra-opis-wrapper">
                            <v-textarea class="universal-vdialog-textfield" type="text" placeholder="Opis tarifne stavke" label="Opis tarifne stavke"
                                v-model="edit_sifra.description"></v-textarea>
                        </div>
                        <div class="vdialog-buttons-wrapper">
                            <div class="universal-vdialog-button vbutton-secondary" @click="clearNewEdit()">
                                Odustani
                            </div>
                            <div class="universal-vdialog-button vbutton-primary" @click="editOld()"> Pohrani
                            </div>
                        </div>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="delete_screen" width="564px">
                    <v-card color="universal-vcard">
                        <div class="universal-vdialog-title">
                            Jeste li sigurni da želite obrisati šifru {{delete_obj.name}}
                        </div>
                        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
                            <div class="universal-vdialog-button vbutton-secondary" @click="delete_screen = false">
                                Odustani </div>
                            <div class="universal-vdialog-button vbutton-primary" @click="finishDelete()">
                                Obriši </div>
                        </div>
                    </v-card>
                </v-dialog>
            </div>
        </div>

    </div>
</template>

<script>
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import SingleSifra from "@/components/sifarnik/SingleSifra.vue";
import RouteTab from "@/components/sifarnik/RouteTab.vue";
import sifra_handler from "@/apiCallers/promise_handler_db/sifarnik.js"
export default {
    components: {
        CustomDropdown,
        SingleSifra,
        RouteTab
    },
    data() {

        return {
            edit_sifra: {
                uid: "",
                name: "",
                number: "",
                description: "",
                parrent_id: null,
                value: 0,
                other_sifarnik: []
            },
            editingMode: false,

            delete_screen: false,
            delete_obj: {
                uid: "",
                name: "",
                description: "",
                number: "",
                parrent_id: null,
                value: 0,
                other_sifarnik: []
            },

            // data for recursion test
            popView: false,
            new_sifra: {
                uid: "",
                description: "",
                name: "",
                number: "",
                parrent_id: null,
                value: 0
            },
            sifra_arr: [],
            selected_type: null,
        };

    },
    async created() {
        await sifra_handler.getAllSifra().then((resp) => {
            this.sifra_arr = resp.data;

        })
    },
    watch: {
        selected_type: function () {
            console.log(this.selected_type);
        },
        "new_sifra.parrent_id": function () {
            this.resetNumber();
        },


    },
    methods: {
        addNew: function (condt) {
            if (condt) {
                this.resetValues()
                this.new_sifra.number = this.sifra_arr.length + 1;
                this.new_sifra.name = "Tbr. " + this.new_sifra.number;
            }
            this.editingMode = false;
            this.popView = true;

        },
        clearNewEdit: function () {
            this.editingMode = false;
            this.popView = false;
        },
        resetValues() {
            this.new_sifra =
            {
                name: "",
                number: "",
                parrent_id: null,
                value: 0
            }
        },
        resetNumber: function () {
            if (this.new_sifra.parrent_id != null) {
                let tmp_parent = this.sifra_arr.find((p) => p.uid == this.new_sifra.parrent_id)
                this.new_sifra.number = tmp_parent.number + "." + parseInt(tmp_parent.other_sifarnik.length + 1);
                this.new_sifra.name = "Tbr. " + this.new_sifra.number;

            } else {
                this.new_sifra.number = this.sifra_arr.length + 1;
                this.new_sifra.name = "Tbr. " + this.new_sifra.number;
            }

        },
        newFromParrent: function (uid) {
            this.resetValues()
            this.new_sifra.parrent_id = uid;
            this.addNew(false);
            this.resetNumber()

        },
        editSingle: function (node) {
            this.edit_sifra = {
                uid: node.uid,
                name: node.name,
                number: node.number,
                parrent_id: node.parrent_id,
                value: node.value,
                other_sifarnik: node.other_sifarnik,
                description: node.description
            },
                this.editingMode = true;
        },
        addNewSifra: async function () {

            await sifra_handler.addNewSifra(this.new_sifra).then((resp) => {
                this.editingMode = false;
                this.popView = false;
                this.sifra_arr = resp.data;
                this.resetValues()
            })

        },
        editOld: async function () {
            await sifra_handler.editSifra(this.edit_sifra).then((resp) => {
                this.editingMode = false;
                this.popView = false;
                this.sifra_arr = resp.data;
                this.resetValues()
            })
        },
        deleteSingle: async function (node) {
            console.log(node)
            this.delete_obj = node;
            this.delete_screen = true;
        },
        finishDelete: async function () {
            await sifra_handler.deleteSifra(this.delete_obj.uid).then((resp) => {
                this.delete_screen = false;
                this.sifra_arr = resp.data;

            })
        },
        mappedAll: function () {
            let temp_arr = [{
                id: null,
                naziv: "KORIJENSKI TABULARNI BROJ"
            }]
            temp_arr = temp_arr.concat
                (this.sifra_arr.map((p) => ({
                    id: p.uid,
                    naziv: p.name
                })))
            return temp_arr;
        }
    },

    mounted() {

        this.$store.state.paginacija.title = "Šifarnici"
        this.selected_type = this.drop_items.find((i) => i.value == 0);
    }

}

</script>

<style>

</style>